<template>
  <section
    class="component-ccea5026"
    resmed-component-name="locator_buyonline_featured_background_title"
    v-bind:style="{
      'background-image': `url(${acf.layout['background-image']})`,
      'background-color': `${acf.layout['background-color']}`,
      'background-size': `${acf.layout['background-size']}`,
    }"
  >
    <div class="component">
      <div class="container px-xs-sm-2">
        <div class="row justify-content-center">
          <div class="col col-xl-10 text-center">
            <h1
              v-bind:class="[acf.layout['headline-size']]"
              v-html="acf.headline"
            ></h1>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "component-ccea5026", // locator_buyonline_featured_background_title
  props: ["acf"],
  created() {
    bus.$emit("navigation:reversed", true);
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";

.component-ccea5026 {
  background-position: center center;
  background-repeat: no-repeat;
  padding: 2.5rem 0 2.25rem 0;

  @media (min-width: 768px) {
    padding: 3.5rem 0 3rem 0;
  }

  @media (min-width: 992px) {
    padding: 10.5rem 0 3rem 0;
  }
}

.component {
  h1 {
    margin: 0;
    color: $cc-resmed-white;
  }
}
</style>